export enum MainMenuCategory {
  plan = 'plan',
  finance = 'finance',
  build = 'build',
  operate = 'operate',
  analytics = 'analytics',
  crm = 'crm',
  credit = 'credit'
}
